<template>
  <PageContainer class="page" height="full">
    <Card height="full">
      <div class="page-content">
        <Text variant="h1">404 Not Found</Text>
        <Text variant="body-large">The page you were looking for could not be found.</Text>
        <Text as="div" variant="body-large">
          <Link :to="{ name: AppRouteNames.HOME }" color="accent">Back to Tallo</Link>
        </Text>
      </div>
    </Card>
  </PageContainer>
</template>

<script setup lang="ts">
import { Card, Link, PageContainer, Text } from '@tallo/design-system';
import { AppRouteNames } from '@tallo/investor/navigation';
</script>

<style lang="scss" scoped>
.page {
  padding-block: 1rem;
}

.page-content {
  padding-top: 2.5rem;
  text-align: center;
}
</style>
